import { ref, nextTick, watch } from 'vue';
import { useTourFiltersStore } from '@/entities/filter/store/tour';
import type { Chip } from '@/entities/tour-activities';
import { arraysEqual, toValues } from '@/shared/lib/arraysEqual';

export function useTourActivitiesSelection() {
  const filtersStore = useTourFiltersStore();

  // Допускаем и строки, и объекты: UiChips может вернуть выбранную опцию целиком.
  const selectedValues = ref<Array<string | Chip>>([]);
  const syncingFromStore = ref(false);

  const applyFromStore = (incoming: string[] | null) => {
    const next = incoming ? [...incoming] : [];
    if (arraysEqual(incoming, toValues(selectedValues.value))) {
      return;
    }
    syncingFromStore.value = true;
    selectedValues.value = next;
    nextTick(() => (syncingFromStore.value = false));
  };

  const applyToStore = (outgoingMixed: Array<string | Chip>) => {
    if (syncingFromStore.value) {
      return;
    }
    const outgoing = toValues(outgoingMixed);
    const current = filtersStore.state.toursActivities as string[] | null;
    if (arraysEqual(current, outgoing)) {
      return;
    }
    filtersStore.state.toursActivities = outgoing.length ? outgoing : null;
  };

  // авто-синк из стора
  watch(
    () => filtersStore.state.toursActivities,
    (v) => applyFromStore(v as string[] | null),
    { immediate: true },
  );

  // локальные изменения → стор
  watch(selectedValues, (val) => applyToStore(val), { deep: true });

  return { selectedValues };
}
